import React from 'react';
import { I18n } from 'react-redux-i18n';

const labelStyle = {
  fontSize: '12px',
  fontWeight: 600,
  marginBottom: '4px',
  display: 'block',
};
const wrapStyle = { marginBottom: 0 };

function SelectField({ field, value, onChange }) {
  return (
    <div className="form-group mb-0" style={wrapStyle}>
      <label htmlFor={`tf-${field.key}`} style={labelStyle}>{field.label}</label>
      <select
        id={`tf-${field.key}`}
        className="form-control form-control-sm"
        value={value}
        onChange={e => onChange(field.key, e.target.value)}
        style={{ minWidth: field.minWidth || '130px' }}
      >
        {field.placeholder !== false && (
          <option value="">{field.placeholder || field.label}</option>
        )}
        {(field.options || []).map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </div>
  );
}

function DateField({ field, value, onChange }) {
  return (
    <div className="form-group mb-0" style={wrapStyle}>
      <label htmlFor={`tf-${field.key}`} style={labelStyle}>{field.label}</label>
      <input
        id={`tf-${field.key}`}
        type="date"
        className="form-control form-control-sm"
        value={value}
        placeholder={field.placeholder || field.label}
        onChange={e => onChange(field.key, e.target.value)}
        style={{ minWidth: field.minWidth || '145px' }}
      />
    </div>
  );
}

function PerPageField({ field, value, onChange }) {
  return (
    <div className="form-group mb-0" style={wrapStyle}>
      <label htmlFor={`tf-${field.key}`} style={labelStyle}>{field.label || I18n.t('itemsPerPage')}</label>
      <select
        id={`tf-${field.key}`}
        className="form-control form-control-sm"
        value={value}
        onChange={e => onChange(field.key, Number(e.target.value))}
        style={{ minWidth: field.minWidth || '150px' }}
      >
        {(field.options || [10, 25, 50, 100]).map(n => (
          <option key={n} value={n}>{n}</option>
        ))}
      </select>
    </div>
  );
}

export default function TableFilters({
  fields = [],
  values = {},
  onChange,
  hasActiveFilters,
  onClear,
}) {
  return (
    <div
      className="row mb-3 align-items-end"
      style={{ padding: '0 15px', gap: '10px', flexWrap: 'wrap' }}
    >
      {fields.map((field) => {
        const value = values[field.key] !== undefined ? values[field.key] : '';
        if (field.type === 'select') {
          return <SelectField key={field.key} field={field} value={value} onChange={onChange} />;
        }
        if (field.type === 'date') {
          return <DateField key={field.key} field={field} value={value} onChange={onChange} />;
        }
        if (field.type === 'perPage') {
          return <PerPageField key={field.key} field={field} value={value} onChange={onChange} />;
        }
        return null;
      })}

      {hasActiveFilters && onClear && (
      <div className="form-group mb-0" style={wrapStyle}>
        <div style={{ ...labelStyle, visibility: 'hidden' }}>·</div>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          style={{ display: 'block' }}
          onClick={onClear}
        >
          {I18n.t('clearFilters')}
        </button>
      </div>
      )}
    </div>
  );
}
